<template>
    <div class="rp-messenger-back-button" >
        <i  @click="onClick" class="el-icon-back" />
    </div>    
</template>
<script>
import MessengerEventBus from '../MessengerEventBus'
export default {
    methods: {
        onClick() {
            MessengerEventBus.$emit("SCENARIO_BACK_BUTTON_CLICK", {})
        }
    }
}
</script>
<style lang="scss" scoped>
.rp-messenger-back-button {
    font-size: 30px;
    line-height: 1;
    padding-bottom: 1rem;
    .el-icon-back {
        cursor: pointer;
    }
    @include for-size(desktop-up){
        font-size: 30px;
    }
}
</style>